import {APIStatusType, OrderEntryType, ScheduledChannelType} from '@web/core/constants'

import type {ActionReducerMapBuilder, SliceCaseReducers} from '@reduxjs/toolkit'

export type ReceivableRewardState = {
    /** api 상태 */
    apiStatus: {
        reviewTarget: APIStatusType
        confirmationTarget: APIStatusType
    }
    /** 패밀리결제 여부 */
    isFamilyPay: boolean
    /** 적립 받은 상품 정보 */
    rewardedItems: Array<RewardedItem>
    /** 리뷰 작성 가능한 상품 정보 */
    reviewableItem: Maybe<{
        /** 대표 상품 주문번호 */
        productOrderNo: string
        /** 상품명 */
        productName: string
        /** 상품 이미지 URL */
        productImageUrl: Maybe<string>
        /** 예상적립금 총 합 */
        totalExpectedReviewRewardPointAmount: Maybe<number>
    }>
    /** 적립을 받을 수 있는 상품 정보 */
    rewardableItem: Maybe<{
        /** 적립 방식 */
        rewardMethod: RewardMethodType
        /** 주문번호 */
        orderNo: string
        /** 상품주문번호 */
        productOrderNo: string
        /** 상품명 */
        productName: string
        /** 상품 이미지 URL */
        productImageUrl: Maybe<string>
        /** 예상 적립금 */
        expectedRewardAmount: number
        /** 패밀리 결제 여부 */
        isFamilyPay: boolean
    }>
}

/** 적립 방식 */
export const RewardMethod = {
    /** 포인트 받기를 통한 적립 */
    RECEIVE_POINT: 'RECEIVE_POINT',
    /** 구매확정 후 적립 */
    AFTER_CONFIRMATION: 'AFTER_CONFIRMATION',
} as const
export type RewardMethodType = Constant<typeof RewardMethod>

type RewardedItem = {
    /** 판매채널 */
    saleChannelType: Maybe<OrderEntryType>
    /** 상품주문번호 */
    productOrderNo: string
    /* 상품주문 상태 */
    productOrderStatus: string
    /** 주문완료 시간 */
    orderDateTime: string
    /** 상품 결제 금액 */
    productPaymentAmount: number
    /** 상품 카테고리 아이디 */
    productCategoryId: Maybe<string>
    /** 네이버 쇼핑 상품 아이디 */
    ecNvMid: Maybe<number>
    /** 가맹점 ID */
    merchantNo: Maybe<number>
    /** 예약 채널 타입  */
    scheduledChannelType: Maybe<ScheduledChannelType>
}

export type ReceivableRewardReducers = SliceCaseReducers<ReceivableRewardState>

export type RootState = {receivableReward: ReceivableRewardState}

export type MakeSliceOptions = {
    extraReducers?: (builder: ActionReducerMapBuilder<ReceivableRewardState>) => void
}
